module.exports = __webpack_public_path__ + "img/bili-logo-red.7e42d506.png";